import * as types from './constants';

// Get Smart Group
export const getSmartGroupRequest = data => (
  { type: types.GET_SMART_GROUP_REQUEST, payload: data }
);

export const getSmartGroupDone = data => (
  { type: types.GET_SMART_GROUP_DONE, payload: data }
);

export const getSmartGroupFailed = errors => (
  { type: types.GET_SMART_GROUP_FAILED, payload: errors }
);

// Update Smart Group
export const updateSmartGroupRequest = data => (
  { type: types.UPDATE_SMART_GROUP_REQUEST, payload: data }
);

export const updateSmartGroupDone = data => (
  { type: types.UPDATE_SMART_GROUP_DONE, payload: data }
);

export const updateSmartGroupFailed = errors => (
  { type: types.UPDATE_SMART_GROUP_FAILED, payload: errors }
);

export const updateSmartGroupReset = errors => (
  { type: types.UPDATE_SMART_GROUP_RESET, payload: errors }
);